import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import SliderOurClients from '../SliderOurClients';


const Footer = () => {
  return (
    <>

      <div className="section-client-slider" style={{ marginTop: "50px" }}>
        <div className="space-x-128">
          <div className="client-slider-style-1">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-xl-3 col-xxl-2">
                  <h4 className="mb-4 mb-xl-0">Our Valuable Clients</h4>
                </div>
                <div className="col-xl-9 col-xxl-10">
                  <div className="client-one swiper swiper-initialized swiper-horizontal">
                    <div className="swiper-wrapper align-items-center" id="swiper-wrapper-7de3a766687d944d" aria-live="off" style={{ transitionDuration: '3000ms', transform: 'translate3d(0px, 0px, 0px)' }}>
                      <SliderOurClients />
                    </div>
                    <span className="swiper-notification" aria-live="assertive" aria-atomic="true" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="section-footer" style={{ marginTop: "20px", overflow:"hidden" }}>
        <div className="footer footer-negative">

          <div className="footer-center mt-lg-5">
            <div className="section-space-bottom">
              <div className="container">
                <div className="row justify-content-xl-between gy-5">
                  <div className="col-auto col-md-6 col-lg-5 col-xl-4">
                    <div className="footer-widget footer-widget-about">
                      <Link to="/">
                        <img src="assets/img/logo.jpg" alt="logo-light" width={200} height={75} style={{ borderRadius: "5px", marginTop:"27px" }} />
                      </Link>
                      {/* <p>Transport all for Solutions Your Business Future</p> */}
                      <p className="section-text text-light mb-5">If you are looking for an impeccable Transportation service in India, you can contact us.</p>

                      <div className="social-menu is-text-link-orange ">
                        <a href="https://www.facebook.com/100064046073062/about/" target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                        <a to="https://www.x.com" target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-instagram" />

                        </a>
                        <a to="https://www.dribbble.com" target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-youtube" />
                        </a>

                      </div>
                    </div>
                  </div>
                  <div className="col-auto col-md-6 col-lg-3 col-xl-auto">
                    <div className="footer-widget footer-widget-nav">
                      <h4 className="footer-title">Quick Links</h4>
                      <nav className="footer-nav">
                        <ul>
                          <li><Link to="/">Home</Link></li>
                          <li><Link to="/about">About Us</Link></li>
                          <li><Link to="/services">View All Services</Link></li>

                        </ul>
                      </nav>
                    </div>
                  </div>
                  <div className="col-auto col-md-6 col-lg-3 col-xl-auto">
                    <div className="footer-widget footer-widget-nav">
                      <h4 className="footer-title">Services</h4>
                      <nav className="footer-nav">
                        <ul>
                          <li><Link to="/blog">Our Blog</Link></li>
                          <li><Link to="/gallery">Our Gallery</Link></li>
                          <li><Link to="/contact-us">Contact Us</Link></li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                  <div className="col-auto col-md-6 col-lg-5 col-xl-3">
                    <div className="footer-widget footer-widget-nav">
                      <h4 className="footer-title">Contact</h4>
                      <ul className="get-touch-info-list">
                        <li>
                          <div className="icon">
                            <i className="fa-light fa-phone" />
                          </div>
                          <div className="content">
                            <span>24/7 Our Support</span>
                            <a href="tel:+91 8770252599" className="text-white">+91 8770252599</a>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <i className="fa-light fa-envelope" />
                          </div>
                          <div className="content">
                            <span>Send Your Message</span>
                            <a href="mailto:Rahullogistics16@gmail.com" className="text-white">Rahullogistics16@gmail.com</a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mapouter" style={{marginTop:"-70px"}}><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1200&height=200&hl=en&q=P8CG+C7G RAHUL LOGISTICS, NH 30, Paduwa, Madhya Pradesh 483442&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://wheremylocation.com/">where am i</a></div><style dangerouslySetInnerHTML={{__html: ".mapouter{position:relative;text-align:right;width:100%;height:200px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:200px;}.gmap_iframe {height:200px!important;}" }} /></div>

          <div className="footer-bottom">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-auto">
                  <p className="copyright-text">  <a style={{ color: "white" }} href="tel:+91 8982471422"> Designed by | © 2026  Rahul Logistics Katni </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <button className="scroll-to-top">
        <i className="fa-regular fa-arrow-up" />
      </button>





      <WhatsappIcon />



    </>
  )
}

export default Footer